// extracted by mini-css-extract-plugin
export var box = "_1v-1";
export var checkboxRow = "_1v-8";
export var checked = "_1v-2";
export var descriptionSpacer = "_1v-a";
export var disabled = "_1v-3";
export var icon = "_1v-6";
export var input = "_1v-0";
export var labelSpacer = "_1v-9";
export var medium = "_1v-5";
export var small = "_1v-4";
export var text = "_1v-7";